/* eslint-disable arrow-body-style */

import { datadogRum } from '@datadog/browser-rum-slim';
import Logger from '../logger';
import { get, post } from '../fetch';
import { COUNTRY_CODE, API_URL } from '../../constants';

const handleCatchError = (error) => {
  Logger.error(error);
  datadogRum.addError(error);
  throw error;
};

// PWL1
const passwordlessSignup = async ({
  phoneNumber,
  verificationCode,
  email,
  name,
  marketingConsentPreference,
  authRef,
}) => {
  const data = {
    verification_code: verificationCode,
    country_code: COUNTRY_CODE,
    phone_number: phoneNumber,
    email,
    name,
    marketing_consent_preference: marketingConsentPreference,
    ...(authRef && {
      metadata: {
        authentication_referer: authRef,
      },
    }),
  };

  return post(API_URL.PWL1, {
    method: 'POST',
    body: JSON.stringify(data),
  }).catch(handleCatchError);
};

// PWL2
const getEmailAvailability = async ({ email }) => {
  const queryParams = new URLSearchParams({
    email,
  });
  const URL = `${API_URL.PWL2}?${queryParams.toString()}`;

  return get(URL).catch(handleCatchError);
};

// PWL3
const getPhoneAvailability = async ({ phoneNumber, verificationCode }) => {
  const data = {
    verification_code: verificationCode,
    country_code: COUNTRY_CODE,
    phone_number: phoneNumber,
  };

  return post(API_URL.PWL3, {
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'include',
  }).catch(handleCatchError);
};

// PWL4
const verifyEmailRecordMatches = async ({ phoneNumber, verificationCode, email }) => {
  const data = {
    verification_code: verificationCode,
    country_code: COUNTRY_CODE,
    phone_number: phoneNumber,
    email,
  };

  return post(API_URL.PWL4, {
    method: 'POST',
    body: JSON.stringify(data),
  }).catch(handleCatchError);
};

// Singpass Init
const singpassInit = async ({ client_id, scope, audience, state, nonce, _csrf, redirect_uri }) => {
  const queryParams = new URLSearchParams({
    client_id,
    scope,
    audience,
    state,
    nonce,
    _csrf,
    redirect_uri,
  });

  return get(`${API_URL.SINGPASS_INIT}?${queryParams.toString()}`).catch(handleCatchError);
};

export default {
  passwordlessSignup,
  getEmailAvailability,
  getPhoneAvailability,
  verifyEmailRecordMatches,
  singpassInit,
};
